import { BroadcastService } from './../../../../core/src/lib/service/broadcast.service';
import { ToasterType } from './../../../../core/src/lib/model/toast-type.model';
import {
	Directive,
	Input,
	Output,
	EventEmitter,
	HostListener
} from '@angular/core';

/**
 * Being able to copy any text into the clipboard.
 * Usage: <button [cvCopyClipboard]="VarOrTextToCopy" type="button">Copy to the Clipboard</button>
 */

@Directive({selector: '[cvCopyClipboard]'})
export class CopyClipboardDirective {

	@Input('cvCopyClipboard') public clipboard: string;
	@Input() public context: string;

	@Output() public copied: EventEmitter<string> = new EventEmitter<string>();

	constructor(private broadcastService: BroadcastService) {}

	@HostListener('click', ['$event'])
	public onClick(event: MouseEvent): void {
		event.preventDefault();
		if (!this.clipboard) {
			return;
		}
		this.copyToClipboard();
	}

	/**
	 * Copy the data into the clipboard
	 */
	public copyToClipboard(): void {
		const listener = (clipBoardEvent: ClipboardEvent): void => {
			const clipboard = clipBoardEvent.clipboardData || window['clipboardData'];
			clipboard.setData('text', this.clipboard.toString());
			clipBoardEvent.preventDefault();
			this.copied.emit(this.clipboard);
		};

		// Create the Copy
		document.addEventListener('copy', listener, false)
		document.execCommand('copy');
		// Remove it after the use
		document.removeEventListener('copy', listener, false);
		this.broadcastService.broadcast({
			name: ToasterType.SUCCESS,
			event: {
				type: 'success',
				message: 'Copied to clipboard.'
			}
		});
	}
}
